import { render } from "./AddEditUserModal.vue?vue&type=template&id=bd597460&scoped=true"
import script from "./AddEditUserModal.vue?vue&type=script&lang=js"
export * from "./AddEditUserModal.vue?vue&type=script&lang=js"

import "./AddEditUserModal.vue?vue&type=style&index=0&id=bd597460&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd597460"]])

export default __exports__